import { twMerge } from 'tailwind-merge';

import { Heading } from '../Heading/Heading';
import { ReactNode } from 'react';

interface IProps {
  className?: string;
  title?: string;
  children?: ReactNode | ReactNode[];
}

export const ModalHeader = ({ className = '', title, ...rest }: IProps) =>
  title ? (
    <div className={twMerge('rounded-t-md border-b p-6', className)} {...rest}>
      <Heading className="mb-0" variant="sm">
        {title}
      </Heading>
    </div>
  ) : (
    <div className={twMerge('rounded-t-md border-b p-6', className)} {...rest} />
  );
